import axios from 'axios'
import config from '@/configPort'
import aes from '@/units/aes'
import qs from 'qs'
console.log(config.API_BASE_URL)
const api = axios.create({
  baseURL: config.API_BASE_URL,
  timeout: 1000 * 60,
  responseType: 'json',
})

api.interceptors.request.use(
  (request) => {
    /**
     * 全局拦截请求发送前提交的参数
     * 以下代码为示例，在请求头里带上 token 信息
     */

    if (request.headers) {
      request.headers.token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MywiaWF0IjoxNjg5NTc1MTUzLjQxODk2OCwidGltZW91dCI6MjU5MjAwMCwidHlwZSI6MX0.pGb9mWJQagzZj6yLrgXBbukoeHI35n0Ar26Hnw11Nsk'
      request.headers['Content-Type'] = 'application/json'
      request.headers['phone_system_type'] = 'www'
    }
    // 是否将 POST 请求参数进行字符串化处理
    if (request.method === 'post') {
      // request.data.phone_system_type = 'www'
      // request.data = qs.stringify(request.data, {
      //   arrayFormat: 'brackets',
      // })
    }
    console.log('请求数据：', request.data)
    // request.data = { "data": aes.encrypt(request.data) }
    return request
  },
)

api.interceptors.response.use(
  (response) => {
    // console.log('response:', response.data)
    // if (parseInt(response.data.code) !== 52002) {
    //   console.log('返回结果')
    //    // 返回数据
    //    return Promise.reject(response.data)

    // }
    // else {
    // //   toLogin()
    // }
    if (parseInt(response.data.code) === 1200) {
      // console.log('返回数据：', aes.decrypt(response.data.data))
      return Promise.resolve(response.data.data)
    } else {
      console.log('报错数据：', aes.decrypt(response.data))
      return Promise.reject(response.data)
    }

  },
  // (error) => {
  //   console.log('error', error)
  //   let message = error.message
  //   if (message === 'Network Error') {
  //     message = '后端网络故障'
  //   }
  //   else if (message.includes('timeout')) {
  //     message = '接口请求超时'
  //   }
  //   else if (message.includes('Request failed with status code')) {
  //     message = `接口${message.substr(message.length - 3)}异常`
  //   }

  //   return Promise.reject(error)
  // },
)

export default api



// WEBPACK FOOTER //
// ./src/api/index.js